import BannerArticleCalendarEvent from './component';

export default BannerArticleCalendarEvent;
